if (!customElements.get('facets-active')) {
  class FacetsActive extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }

    onClick(event) {
      const toggle = event.target.closest('.facets-active__toggle');
      if (!toggle || !this.contains(toggle)) return;

      event.preventDefault();
      this.classList.add('is-expanded');
      toggle.setAttribute('aria-expanded', 'true');
    }

    resetExpandedState() {
      this.classList.remove('is-expanded');
      this.querySelector('.facets-active__toggle')?.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('facets-active', FacetsActive);
}
